import React from 'react';

export const Loading = () => (
    <div className="container text-center ">
        <div className="text-center mt-5" >
            <p>
                <strong>Загрузка...</strong>
            </p>
            <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
        </div>
    </div>
);